import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const symptoms = ['Te despiertas cansada aunque hayas dormido bien', 'Tu vientre luce más grande en la tarde', 'Sientes presión o pesadez en el lado derecho', 'El bajón de energía de las 3 PM te destruye', 'Tu mente está nublada y no puedes concentrarte', 'Tienes antojos de azúcar incontrolables', 'Tu ropa de hace 6 meses ya no cierra igual', 'Te sientes inflamada después de cada comida'];
export function SymptomsSection() {
  const [checkedItems, setCheckedItems] = useState<number[]>([]);
  const toggleItem = (index: number) => {
    if (checkedItems.includes(index)) {
      setCheckedItems(checkedItems.filter(i => i !== index));
    } else {
      setCheckedItems([...checkedItems, index]);
    }
  };
  return <SectionWrapper bgColor="warmWhite" data-id="element-286">
      <h2 className="font-serif text-3xl md:text-4xl font-bold text-dark mb-6 leading-tight text-center" data-id="element-287">
        ¿Reconoces Alguna de Estas Señales?
      </h2>

      <div className="bg-white rounded-3xl shadow-soft p-5 md:p-6 mb-6 border border-gray-100" data-id="element-288">
        <p className="text-sm text-gray-500 mb-4 text-center italic" data-id="element-289">
          Toca las que apliquen para ti:
        </p>

        <div className="space-y-3" data-id="element-290">
          {symptoms.map((symptom, index) => {
          const isChecked = checkedItems.includes(index);
          return <motion.button key={index} whileTap={{
            scale: 0.98
          }} onClick={() => toggleItem(index)} className={`
                  w-full flex items-start gap-4 p-4 rounded-xl text-left transition-all duration-200
                  ${isChecked ? 'bg-primary/10 border-primary/30' : 'bg-gray-50 border-transparent hover:bg-gray-100'}
                  border
                `} data-id="element-291">
                <div className={`
                  w-6 h-6 rounded-md flex items-center justify-center shrink-0 mt-0.5 transition-colors
                  ${isChecked ? 'bg-primary text-white' : 'bg-white border-2 border-gray-300'}
                `} data-id="element-292">
                  {isChecked && <Check className="w-4 h-4" data-id="element-293" />}
                </div>
                <span className={`font-sans text-base md:text-lg ${isChecked ? 'text-primary font-medium' : 'text-gray-700'}`} data-id="element-294">
                  {symptom}
                </span>
              </motion.button>;
        })}
        </div>

        {checkedItems.length >= 3 && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} className="mt-6 p-4 bg-urgency/10 text-urgency rounded-xl border border-urgency/20 font-medium text-center" data-id="element-295">
            Has marcado {checkedItems.length} señales. Tu hígado necesita
            atención urgente.
          </motion.div>}
      </div>

      <div className="font-sans text-lg text-gray-800 space-y-4 leading-relaxed text-center" data-id="element-296">
        <p data-id="element-297">
          Si marcaste 3 o más de estas señales, tu hígado está enviándote una
          alerta.
        </p>

        <p data-id="element-298">Y cada mes que pasa sin atenderla, la acumulación avanza.</p>

        <p data-id="element-299">
          Lo que hoy es "hígado graso leve" puede convertirse mañana en
          resistencia a la insulina, colesterol elevado y problemas hormonales
          que son mucho más difíciles de revertir.
        </p>

        <div className="mt-5 p-5 bg-accent/10 rounded-2xl border border-accent/30" data-id="element-300">
          <p className="font-serif text-xl md:text-2xl font-bold text-dark" data-id="element-301">
            El mejor momento para actuar fue hace un año.{' '}
            <br className="hidden md:block" data-id="element-302" />
            <span className="text-accent" data-id="element-303">
              El segundo mejor momento es hoy.
            </span>
          </p>
        </div>
      </div>
    </SectionWrapper>;
}